import { Accordion, Badge, Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";
// import DataTable from "datatables.net-bs5";
import * as moment from "moment";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
// import Datepickers from '../../../components/Datepickers.js';
// import { get } from "sortablejs";
import DataTable from "react-data-table-component";
import avatar1 from "../../../assets/images/avatars/01.png"
import eyeIcon from "../../../assets/images/icons/eye.svg"
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { allUsersSignal } from "../../../signal/allUsersSignal";
import PlanTripModal from "./PlanTripModal";
import ModalImage from "react-modal-image";

export default function TripsList() {

    let today = Date.now();
    // get date start Time of 7 days ago in milliseconds
    let sevenDaysAgo = new Date(today - 7 * 24 * 60 * 60 * 1000).getTime();

    const [searchParams, setSearchParams] = useSearchParams();
    const [trips, setTrips] = useState([]);
    const [tripsToDisplay, setTripsToDisplay] = useState([]);
    const [fromDate, setFromDate] = useState(searchParams.get("fromDate") ? searchParams.get("fromDate") : moment(sevenDaysAgo).format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(searchParams.get("toDate") ? searchParams.get("toDate") : moment(today).format("YYYY-MM-DD"));
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState(searchParams.get("statusFilter") ? searchParams.get("statusFilter") : "");
    const [minExpense, setMinExpense] = useState(searchParams.get("minExpense") ? parseFloat(searchParams.get("minExpense")) : 0);
    const [maxExpense, setMaxExpense] = useState(searchParams.get("maxExpense") ? parseFloat(searchParams.get("maxExpense")) : 0);
    const [minDistance, setMinDistance] = useState(searchParams.get("minDistance") ? parseFloat(searchParams.get("minDistance")) : 0);
    const [maxDistance, setMaxDistance] = useState(searchParams.get("maxDistance") ? parseFloat(searchParams.get("maxDistance")) : 0);
    const [minNewCustomers, setMinNewCustomers] = useState(searchParams.get("minNewCustomers") ? parseInt(searchParams.get("minNewCustomers")) : 0);
    const [maxNewCustomers, setMaxNewCustomers] = useState(searchParams.get("maxNewCustomers") ? parseInt(searchParams.get("maxNewCustomers")) : 0);
    const [showPlanTripModal, setShowPlanTripModal] = useState(false)


    const navigate = useNavigate();

    const refetchTrips = () => {
        getTrips.refetch({ cancelRefetch: true });
    }

    const handleDisplayFields = () => {
        setTripsToDisplay(trips.filter((item) => {

            if (statusFilter && statusFilter !== "") {
                if (statusFilter === "scheduled" && item.isStarted === true) return false;
                if (statusFilter === "on going" && (item.isCompleted === true || moment().startOf('day').valueOf() !== item?.date)) return false;
                if (statusFilter === "completed" && (item.isStarted === false || item.isCompleted === false || item?.isNotEnded)) return false;
                if (statusFilter === "not ended" && (!item.isStarted || (!item.isCompleted && moment().startOf('day').valueOf() === item?.date) || (item.isCompleted && !item?.isNotEnded))) return false;
            }
            if (minExpense && item.totalExpense < minExpense) return false;
            if (maxExpense && item.totalExpense > maxExpense) return false;
            if (minDistance && parseFloat(item?.totalDistance / 1000)?.toFixed(2) < parseFloat(minDistance)) return false;
            if (maxDistance && parseFloat(item?.totalDistance / 1000)?.toFixed(2) > parseFloat(maxDistance)) return false;
            if (minNewCustomers && item.totalNewCustomers < minNewCustomers) return false;
            if (maxNewCustomers && item.totalNewCustomers > maxNewCustomers) return false;
            if (search === "") return true;
            if (moment(item?.date).format("DD/MM/YY").toLowerCase().includes(search.toLowerCase())) return true;
            if (allUsersSignal.value[item.userId] && allUsersSignal.value[item.userId]?.name.toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.startTime && moment(item?.startTime).format("hh:mm A").toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.endTime && moment(item?.endTime).format("hh:mm A").toLowerCase().includes(search.toLowerCase())) return true;
            if (parseFloat(item?.totalDistance / 1000)?.toFixed(2)?.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (parseFloat(item?.totalExpense).toFixed(2)?.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.totalNewCustomers?.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.tasksCompleted?.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.tasks?.length.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item.isStarted === true && "started".startsWith(search.toLowerCase())) return true;
            if (item.isStarted === false && "scheduled".startsWith(search.toLowerCase())) return true;
            if (item.isCompleted === true && !item?.isNotEnded && "completed".startsWith(search.toLowerCase())) return true;
            if (item.isCompleted === false && moment().startOf('day').valueOf() === item.date && "on going".startsWith(search.toLowerCase())) return true;
            if (((item.isCompleted === false && moment().startOf('day').valueOf() !== item.date) || item?.isNotEnded) && item?.isStarted && "not ended".startsWith(search.toLowerCase())) return true;
            return false;
        }))
    }

    const handleFilters = async () => {

        const tempSearchParam = new URLSearchParams({ fromDate: fromDate, toDate: toDate, minExpense: minExpense, maxExpense: maxExpense, minDistance: minDistance, maxDistance: maxDistance, minNewCustomers: minNewCustomers, maxNewCustomers: maxNewCustomers, statusFilter: statusFilter })
        setSearchParams(tempSearchParam);

        await refetchTrips();
        handleDisplayFields();
    }

    useEffect(() => {
        handleDisplayFields();
    }, [search, trips])

    const getTrips = useQuery("trips", async () => {
        let resp = await axios.get(`${DEV_SERVER}/trip/v2/getAllTrips?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 999)}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                let stateName = window.localStorage.getItem("state");
                let temp = data.data
                if (stateName) {
                    temp = temp.filter((item) => {
                        return allUsersSignal.value[item.userId]?.state === stateName
                    })
                }

                setTrips(temp);

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    useEffect(() => {
        refetchTrips();
    }, [])

    const columns = [
        {
            name: "Date",
            center: true,
            selector: "date",
            cell: (row) => `${moment(row?.date).format("DD/MM/YY")}`,
            sortable: true,
        },
        {
            name: "User",
            selector: (row) => {
                if (row?.userId?.length) {
                    return (
                        <div onClick={() => navigate(`/dashboard/trips/${row?.id}`)} className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
                            <img
                                style={{ width: "20px", height: "20px" }}
                                src={(allUsersSignal.value[row?.userId]?.profileURL === "" || allUsersSignal.value[row?.userId]?.profileURL === undefined) ? avatar1 : allUsersSignal.value[row?.userId]?.profileURL}
                                className="rounded-circle avatar-xs"
                                alt="friend"
                            />
                            <OverlayTrigger placement="top" overlay={
                                <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                                    {allUsersSignal.value[row?.userId]?.name}
                                </Tooltip>}>
                                <span style={{ width: "100%" }}>{allUsersSignal.value[row?.userId]?.name}</span>
                            </OverlayTrigger>
                        </div>
                    )
                }
                return "-"
            }
        },
        {
            name: "Status",
            center: true,
            selector: (row) => {
                if (!row?.isStarted) {
                    return <Badge onClick={() => navigate(`/dashboard/trips/${row?.id}`)} bg="secondary" text="white">Scheduled</Badge>
                }
                else if (!row?.isCompleted) {
                    if (moment().startOf('day').valueOf() !== row?.date) {
                        return <Badge onClick={() => navigate(`/dashboard/trips/${row?.id}`)} bg="danger" text="white">Not Ended</Badge>
                    }
                    return <Badge onClick={() => navigate(`/dashboard/trips/${row?.id}`)} bg="warning" text="white">On Going</Badge>
                }
                else {
                    if (row?.isNotEnded) {
                        return <Badge onClick={() => navigate(`/dashboard/trips/${row?.id}`)} bg="danger" text="white">Not Ended</Badge>
                    }
                    return <Badge onClick={() => navigate(`/dashboard/trips/${row?.id}`)} bg="success" text="white">Completed</Badge>
                }
            }
        },
        {
            name: "Start Time",
            center: true,
            selector: "startTime",
            sortable: true,
            cell: (row) => {
                if (row?.isStarted) {
                    return <OverlayTrigger placement="top" overlay={
                        <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                            {`${parseFloat(row?.startKM).toFixed(2)} km`}
                        </Tooltip>}>


                        <span className="d-flex flex-column align-items-center" style={{ rowGap: "0.5rem" }}>

                            <span className="d-flex align-items-center">
                                {parseFloat(row?.startKM) > 0 && `${parseFloat(row?.startKM).toFixed(2)} km`}

                                {row?.startImage !== "" && <ModalImage
                                    showRotate={true}
                                    className="ms-2"
                                    hideDownload={true}
                                    small={eyeIcon}
                                    large={row?.startImage}
                                    alt="Start Image"
                                />}
                            </span>
                            <p className="m-0">{moment(row?.startTime).format("hh:mm A")}</p>
                        </span>
                    </OverlayTrigger>
                }
                return "-"

            }
        },
        {
            name: "End Time",
            center: true,
            selector: "endTime",
            sortable: true,
            cell: (row) => {
                if (row?.isCompleted) {
                    return <OverlayTrigger placement="top" overlay={
                        <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                            {`${parseFloat(row?.endKM).toFixed(2)} km`}
                        </Tooltip>}>


                        <span className="d-flex flex-column align-items-center" style={{ rowGap: "0.5rem" }}>

                            <span className="d-flex align-items-center">
                                {parseFloat(row?.endKM) > 0 && `${parseFloat(row?.endKM).toFixed(2)} km`}

                                {row?.endImage !== "" && <ModalImage
                                    showRotate={true}
                                    className="ms-2"
                                    hideDownload={true}
                                    small={eyeIcon}
                                    large={row?.endImage}
                                    alt="Start Image"
                                />}
                            </span>
                            <p className="m-0">{moment(row?.endTime).format("hh:mm A")}</p>
                        </span>
                    </OverlayTrigger>
                }
                return "-"

            }
        },
        {
            name: "Manual km",
            center: true,
            selector: "manualKM",
            cell: (row) => {
                if (row?.manualDistance) {
                    return `${parseFloat(row?.manualDistance / 1000).toFixed(2)} km`
                }
                return "-"
            },
            sortable: true,
        },
        {
            name: "Auto KM",
            center: true,
            selector: "autoCalculatedDistance",
            cell: (row) => `${(row?.autoCalculatedDistance / 1000).toFixed(2)} km`,
            sortable: true,
        },
        {
            name: "New Customers",
            center: true,
            selector: (row) => row?.totalNewCustomers,
            sortable: true,
        },
        {
            name: "Expense",
            center: true,
            selector: "totalExpense",
            cell: (row) => `${parseFloat(row?.totalExpense).toFixed(2)} Rs`,
            sortable: true,
        },
        {
            name: "Route",
            center: true,
            width: "300px",
            selector: "tasks",
            cell: (row) => {
                if(row?.route && row?.route !== ""){
                    return row?.route
                }
                let str = ""

                let tasks = row?.tasks || []
                for (let i = 0; i < tasks?.length; i++) {
                    if (i === 0) {
                        if (tasks[i]?.destinationArea) {
                            str += `${tasks[i]?.destinationArea}, `
                        }
                        if (tasks[i]?.destinationCity) {
                            str += `${tasks[i]?.destinationCity}, `
                        }
                        if (tasks[i]?.destinationState) {
                            str += `${tasks[i]?.destinationState}, `
                        }
                    } else {
                        if (str !== "") {
                            str += " -> "
                        }

                        if (tasks[i]?.destinationArea && tasks[i]?.destinationArea !== row?.tasks[i - 1]?.destinationArea) {
                            str += `${tasks[i]?.destinationArea}, `
                        }
                        if (tasks[i]?.destinationCity && tasks[i]?.destinationCity !== row?.tasks[i - 1]?.destinationCity) {
                            str += `${tasks[i]?.destinationCity}, `
                        }
                        if (tasks[i]?.destinationState && tasks[i]?.destinationState !== row?.tasks[i - 1]?.destinationState) {
                            str += `${tasks[i]?.destinationState}, `
                        }
                    }

                }
                return str
            }
        }
        // {
        //     name: "Task Completed",
        //     center: true,
        //     selector: (row) => ,
        //     sortable: true,
        // },
        // {
        //     name: "Action",
        //     center: true,
        //     selector: (row) => {
        //         return <Link to={`/dashboard/trips/${row?.id}`}>View</Link>
        //     }
        // }
    ]

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Trip List</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Filters</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="flex-wrap" style={{ display: "flex", alignItems: "center", columnGap: "1rem", rowGap: "0.7rem", marginBottom: "1rem" }}>
                                                <div>
                                                    <label htmlFor="fromDate">From Date</label>
                                                    <input type="date" id="fromDate" className="form-control vanila-datepicker" names="start" placeholder="From Date" defaultValue={fromDate} onChange={(e) => {
                                                        setFromDate(e.target.value)

                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="toDate">To Date</label>
                                                    <input type="date" id="toDate" className="form-control vanila-datepicker" names="start" placeholder="To Date" defaultValue={toDate} onChange={(e) => {
                                                        setToDate(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="minExpense">Min Expense</label>
                                                    <input type="number" id="minExpense" className="form-control vanila-datepicker" names="start" placeholder="Min Expense" value={minExpense} onChange={(e) => {
                                                        setMinExpense(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="maxExpense">Max Expense</label>
                                                    <input type="number" id="maxExpense" className="form-control vanila-datepicker" names="start" placeholder="Max Expense" value={maxExpense} onChange={(e) => {
                                                        setMaxExpense(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="minDistance">Min Distance</label>
                                                    <input type="number" id="minDistance" className="form-control vanila-datepicker" names="start" placeholder="Min Distance" value={minDistance} onChange={(e) => {
                                                        setMinDistance(e.target.value)

                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="maxDistance">Max Distance</label>
                                                    <input type="number" id="maxDistance" className="form-control vanila-datepicker" names="start" placeholder="Max Distance" value={maxDistance} onChange={(e) => {
                                                        setMaxDistance(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="minNewCustomers">Min Customers</label>
                                                    <input type="number" id="minNewCustomers" className="form-control vanila-datepicker" names="start" placeholder="Min New Customers" value={minNewCustomers} onChange={(e) => {
                                                        setMinNewCustomers(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="maxNewCustomers">Max Customers</label>
                                                    <input type="number" id="maxNewCustomers" className="form-control vanila-datepicker" names="start" placeholder="Max New Customers" value={maxNewCustomers} onChange={(e) => {
                                                        setMaxNewCustomers(e.target.value)
                                                    }} />
                                                </div>

                                                <div>
                                                    <label htmlFor="statusFilter">Status</label>
                                                    <select id="statusFilter" className="form-control vanila-datepicker" names="start" placeholder="Status" value={statusFilter} onChange={(e) => {
                                                        setStatusFilter(e.target.value)
                                                    }}>
                                                        <option value="">All</option>
                                                        <option value="scheduled">Scheduled</option>
                                                        <option value="on going">On Going</option>
                                                        <option value="not ended">Not Ended</option>
                                                        <option value="completed">Completed</option>
                                                    </select>
                                                </div>

                                            </div>
                                            <div className="d-flex justify-content-end" style={{ columnGap: '1rem' }}>
                                                <button className="btn btn-light ms-2" onClick={() => {
                                                    setFromDate(moment(sevenDaysAgo).format("YYYY-MM-DD"));
                                                    setToDate(moment(today).format("YYYY-MM-DD"));
                                                    setMinExpense(0);
                                                    setMaxExpense(0);
                                                    setMinDistance(0);
                                                    setMaxDistance(0);
                                                    setMinNewCustomers(0);
                                                    setMaxNewCustomers(0);
                                                    setStatusFilter("");
                                                    const tempSearchParam = new URLSearchParams({ fromDate: moment(sevenDaysAgo).format("YYYY-MM-DD"), toDate: moment(today).format("YYYY-MM-DD"), minExpense: 0, maxExpense: 0, minDistance: 0, maxDistance: 0, minNewCustomers: 0, maxNewCustomers: 0, statusFilter: "", page : 1, perPage : 10 });
                                                    setSearchParams(tempSearchParam);
                                                }}>Reset</button>
                                                <button className="btn btn-primary" onClick={handleFilters}>Apply changes</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                <div className="mt-3" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", columnGap: "1rem", marginBottom: "1rem" }}>
                                    <div>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => {
                                            setSearch(e.target.value)
                                        }} />
                                    </div>
                                    <button className="btn btn-primary" onClick={() => {
                                        setShowPlanTripModal(true);
                                    }}>Plan a Trip</button>
                                </div>
                                {(!getTrips.isLoading && !getTrips?.isFetching) && <DataTable
                                    columns={columns}
                                    data={tripsToDisplay}
                                    pagination={true}
                                    onRowClicked={(row) => navigate(`/dashboard/trips/${row?.id}`)}
                                    customStyles={
                                        {
                                            rows: {
                                                style: {
                                                    cursor: "pointer",
                                                    backgroundColor: "unset"
                                                }
                                            }
                                        }
                                    }
                                    paginationPerPage={searchParams.get("perPage") ? parseInt(searchParams.get("perPage")) : 10}
                                    paginationDefaultPage={searchParams.get("page") ? parseInt(searchParams.get("page")) : 1}
                                    onChangeRowsPerPage={(e, page) => {
                                        let currentSearchParam = searchParams
                                        currentSearchParam.set("perPage", e)
                                        setSearchParams(currentSearchParam)
                                    }}

                                    onChangePage={(page) => {
                                        let currentSearchParam = searchParams
                                        currentSearchParam.set("page", page)
                                        setSearchParams(currentSearchParam)
                                    }}
                                />}
                                {(getTrips.isLoading || getTrips?.isFetching) && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            {showPlanTripModal && <PlanTripModal show={showPlanTripModal} close={() => setShowPlanTripModal(false)} refetchTrips={refetchTrips} />}
        </>
    )
}